var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RemoveButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../elements/Basic");

var _Logos = require("../Basic/Logos");

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Favourites/Favourite.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var RemoveButton = function RemoveButton(_ref) {
  var onPress = _ref.onPress;
  return _react.default.createElement(_Touchable.default, {
    position: "absolute",
    right: -5,
    top: 0,
    onPress: onPress,
    width: 15,
    height: 15,
    borderRadius: 7.5,
    bg: "border.accent",
    center: true,
    isFlex: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }, _react.default.createElement(_Basic.Text, {
    size: "custom",
    lineHeight: "15px",
    fontSize: "15px",
    color: "white",
    center: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 9
    }
  }, "-"));
};

exports.RemoveButton = RemoveButton;

var Favourite = function (_React$Component) {
  (0, _inherits2.default)(Favourite, _React$Component);

  var _super = _createSuper(Favourite);

  function Favourite(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Favourite);
    _this = _super.call(this, props);

    _this.onLongPress = function () {
      _this.setState({
        showRemove: !_this.state.showRemove
      });
    };

    _this.state = {
      showRemove: _this.props.showRemove
    };
    return _this;
  }

  (0, _createClass2.default)(Favourite, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          onPress = _this$props.onPress,
          onRemove = _this$props.onRemove,
          imageType = _this$props.imageType,
          href = _this$props.href,
          NavWrapper = _this$props.NavWrapper,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["icon", "title", "onPress", "onRemove", "imageType", "href", "NavWrapper"]);
      return _react.default.createElement(_Touchable.default, (0, _extends2.default)({
        onPress: onPress,
        NavWrapper: NavWrapper,
        href: href
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 13
        }
      }), _react.default.createElement(_Basic.Column, {
        mx: 2,
        centerHorizontal: true,
        position: "relative",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56,
          columnNumber: 17
        }
      }, _react.default.createElement(_Logos.CircleLogo, {
        size: 48,
        src: icon,
        imageType: imageType,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 21
        }
      }), title ? _react.default.createElement(_Basic.Row, {
        maxWidth: 56,
        wrapContent: true,
        style: {
          fontSize: 'small'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59,
          columnNumber: 25
        }
      }, _react.default.createElement(_Basic.Text, {
        numberOfLines: 1,
        size: "small",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 29
        }
      }, title)) : null, this.state.showRemove ? _react.default.createElement(RemoveButton, {
        onPress: onRemove,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 46
        }
      }) : null));
    }
  }]);
  return Favourite;
}(_react.default.Component);

exports.default = Favourite;
Favourite.propTypes = {
  icon: _propTypes.default.string,
  title: _propTypes.default.string,
  onPress: _propTypes.default.func,
  onRemove: _propTypes.default.func,
  showRemove: _propTypes.default.bool,
  imageType: _propTypes.default.string,
  href: _propTypes.default.string
};